// @ts-strict-ignore
import clsx from 'clsx'
import { ReactNode, useRef, useState } from 'react'

import { Button } from '@/shared/ui'

import cl from './AccordionText.module.scss'

export const AccordionText = (props: { children: ReactNode; className: string }) => {
	const { children, className } = props
	const [isOpen, setIsOpen] = useState(false)
	const ref = useRef(null)
	const heightWrapper = isOpen ? ref.current.scrollHeight + 'px' : '0px'

	const handleClick = () => {
		setIsOpen(prevState => !prevState)
	}
	return (
		<div className={clsx(cl.main)}>
			<div style={{ maxHeight: `${heightWrapper}` }} className={cl.collapse}>
				<div className={clsx(cl.content, className)} ref={ref}>
					{children}
				</div>
			</div>
			<Button theme={'link'} className={clsx(cl.btn, { [cl.btn_marginContent]: isOpen })} onClick={handleClick}>
				{isOpen ? 'Скрыть' : 'Показать еще'}
			</Button>
		</div>
	)
}
